<template>
	<div class="root-wrap">
		<!-- <div class="fx-fill fx-center-middle">
            <div>当前地址{{$route.fullPath}}</div>
            <div>当前参数{{query}}</div>
        </div> -->

		<van-button @click="o">清除密码</van-button>
	</div>
</template>
<script>
export default {
	data() {
		return {};
	},

	methods: {
		o() {
			let userInfo = JSON.parse(localStorage.getItem("userInfo"));
			this.$set(userInfo, "payPassword", "");
			localStorage.setItem("userInfo", JSON.stringify(userInfo));
			this.$toast.success("会员信息修改成功！");
		},
	},
};
</script>
<style lang="scss" scoped>
</style>